module.exports = __webpack_public_path__ + "static/cg-header-logo-5ec2754a8cff69c61611ffbd7a1f3666.png";